// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_sections.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ListVersionsResponse, RfiSectionDocumentSnapshot } from "../../docs/v1/docs_pb";
/**
 * ----- WRT-06: RFI Home -----
 *
 * @generated from message mono.projectdata.v1.GetRfiWorkspaceHomeRequest
 */ export class GetRfiWorkspaceHomeRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiWorkspaceHomeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiWorkspaceHomeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiWorkspaceHomeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiWorkspaceHomeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiWorkspaceHomeRequest, "runtime", proto3);
_define_property(GetRfiWorkspaceHomeRequest, "typeName", "mono.projectdata.v1.GetRfiWorkspaceHomeRequest");
_define_property(GetRfiWorkspaceHomeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiHomeKpis
 */ export class RfiHomeKpis extends Message {
    static fromBinary(bytes, options) {
        return new RfiHomeKpis().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiHomeKpis().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiHomeKpis().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiHomeKpis, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 answers_final = 1;
   */ _define_property(this, "answersFinal", 0), /**
   * @generated from field: int32 answers_total = 2;
   */ _define_property(this, "answersTotal", 0), /**
   * @generated from field: int32 in_review = 3;
   */ _define_property(this, "inReview", 0), /**
   * @generated from field: int32 drafting = 4;
   */ _define_property(this, "drafting", 0), /**
   * @generated from field: int32 not_started = 5;
   */ _define_property(this, "notStarted", 0), /**
   * @generated from field: int32 no_owner = 6;
   */ _define_property(this, "noOwner", 0), /**
   * @generated from field: repeated int32 no_owner_question_numbers = 7;
   */ _define_property(this, "noOwnerQuestionNumbers", []), /**
   * response document budget (WRT-13: exact > app.xml > words/words_per_page)
   *
   * @generated from field: double pages_estimate = 8;
   */ _define_property(this, "pagesEstimate", 0), /**
   * @generated from field: double page_limit = 9;
   */ _define_property(this, "pageLimit", 0), /**
   * ceil((response_due - now) / 1 day); -1 when no due
   *
   * @generated from field: int32 days_left = 10;
   */ _define_property(this, "daysLeft", 0), /**
   * min internal_due over not-final sections
   *
   * @generated from field: google.protobuf.Timestamp next_internal_due = 11;
   */ _define_property(this, "nextInternalDue", void 0), /**
   * "estimate" | "app_xml" | "exact"
   *
   * @generated from field: string pages_basis = 12;
   */ _define_property(this, "pagesBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiHomeKpis, "runtime", proto3);
_define_property(RfiHomeKpis, "typeName", "mono.projectdata.v1.RfiHomeKpis");
_define_property(RfiHomeKpis, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "answers_final",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "answers_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "in_review",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "drafting",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "not_started",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "no_owner",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "no_owner_question_numbers",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 8,
            name: "pages_estimate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "page_limit",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "days_left",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "next_internal_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "pages_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiHomeQuestionRow
 */ export class RfiHomeQuestionRow extends Message {
    static fromBinary(bytes, options) {
        return new RfiHomeQuestionRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiHomeQuestionRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiHomeQuestionRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiHomeQuestionRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 number = 1;
   */ _define_property(this, "number", 0), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string question_id = 3;
   */ _define_property(this, "questionId", ""), /**
   * source originalText, verbatim (view_sensitive; empty when masked)
   *
   * @generated from field: string question_text = 4;
   */ _define_property(this, "questionText", ""), /**
   * @generated from field: string owner_user_id = 5;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string owner_name = 6;
   */ _define_property(this, "ownerName", ""), /**
   * not_started|drafting|in_review|final|final_edited|orphaned (§3.6)
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * rfi_response_sections.starts_from.label; else scope note; else ""
   *
   * @generated from field: string starts_from_label = 8;
   */ _define_property(this, "startsFromLabel", ""), /**
   * source kind for the label, or "scope_note"
   *
   * @generated from field: string starts_from_kind = 9;
   */ _define_property(this, "startsFromKind", ""), /**
   * @generated from field: repeated string scoped_capture_project_ids = 10;
   */ _define_property(this, "scopedCaptureProjectIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiHomeQuestionRow, "runtime", proto3);
_define_property(RfiHomeQuestionRow, "typeName", "mono.projectdata.v1.RfiHomeQuestionRow");
_define_property(RfiHomeQuestionRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "question_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "starts_from_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "starts_from_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "scoped_capture_project_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiHomeSignal
 */ export class RfiHomeSignal extends Message {
    static fromBinary(bytes, options) {
        return new RfiHomeSignal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiHomeSignal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiHomeSignal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiHomeSignal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * v2.3: template with {{n}} placeholders (rfi_signals.body)
   *
   * @generated from field: string body = 3;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string status_label = 6;
   */ _define_property(this, "statusLabel", ""), /**
   * @generated from field: string review_href = 7;
   */ _define_property(this, "reviewHref", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.RfiSignalLink links = 9;
   */ _define_property(this, "links", []), /**
   * every {{n}} replaced by its read-time label (GRW-13 thread, Assist)
   *
   * @generated from field: string rendered_body = 10;
   */ _define_property(this, "renderedBody", ""), /**
   * the caller posted this manual signal and may retract it
   *
   * @generated from field: bool can_retract = 11;
   */ _define_property(this, "canRetract", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiHomeSignal, "runtime", proto3);
_define_property(RfiHomeSignal, "typeName", "mono.projectdata.v1.RfiHomeSignal");
_define_property(RfiHomeSignal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "review_href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "links",
            kind: "message",
            T: RfiSignalLink,
            repeated: true
        },
        {
            no: 10,
            name: "rendered_body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "can_retract",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * v2.3: one placeholder of a signal body, labelled at read time.
 *
 * @generated from message mono.projectdata.v1.RfiSignalLink
 */ export class RfiSignalLink extends Message {
    static fromBinary(bytes, options) {
        return new RfiSignalLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSignalLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSignalLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSignalLink, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 ordinal = 1;
   */ _define_property(this, "ordinal", 0), /**
   * ABOUT | RELEVANT_TO
   *
   * @generated from field: string link_role = 2;
   */ _define_property(this, "linkRole", ""), /**
   * CONTACT|COMPANY|GOVERNMENT_ORG|VEHICLE|LABOR_CATEGORY_ANCHOR|PURSUIT|RFI_QUESTION|REVIEW_ITEM
   *
   * @generated from field: string target_kind = 3;
   */ _define_property(this, "targetKind", ""), /**
   * effective id: candidate decision + merge pointer followed; "" while pending
   *
   * @generated from field: string target_id = 4;
   */ _define_property(this, "targetId", ""), /**
   * read time; "" when restricted
   *
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string href = 6;
   */ _define_property(this, "href", ""), /**
   * linked | pending | restricted
   *
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * set while pending (opens the confirm prompt via ListRfiEntities)
   *
   * @generated from field: string candidate_id = 8;
   */ _define_property(this, "candidateId", ""), /**
   * the observed text from REG-54's candidate payload, shown only while pending
   *
   * @generated from field: string pending_label = 9;
   */ _define_property(this, "pendingLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSignalLink, "runtime", proto3);
_define_property(RfiSignalLink, "typeName", "mono.projectdata.v1.RfiSignalLink");
_define_property(RfiSignalLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "link_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "pending_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * v2.3: the observation a user types (or a notice item); zou maps it 1:1 onto
 * REG-54's EntityObservation.
 *
 * @generated from message mono.projectdata.v1.RfiEntityObservation
 */ export class RfiEntityObservation extends Message {
    static fromBinary(bytes, options) {
        return new RfiEntityObservation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEntityObservation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEntityObservation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEntityObservation, a, b);
    }
    constructor(data){
        super(), /**
   * CONTACT | COMPANY | GOVERNMENT_ORG | VEHICLE
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string first_name = 3;
   */ _define_property(this, "firstName", ""), /**
   * @generated from field: string last_name = 4;
   */ _define_property(this, "lastName", ""), /**
   * @generated from field: string email = 5;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 6;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string title = 7;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string uei = 8;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage = 9;
   */ _define_property(this, "cage", ""), /**
   * @generated from field: string org_code = 10;
   */ _define_property(this, "orgCode", ""), /**
   * @generated from field: string agency = 11;
   */ _define_property(this, "agency", ""), /**
   * @generated from field: string sub_agency = 12;
   */ _define_property(this, "subAgency", ""), /**
   * @generated from field: string contract_number = 13;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string employer_hint = 14;
   */ _define_property(this, "employerHint", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEntityObservation, "runtime", proto3);
_define_property(RfiEntityObservation, "typeName", "mono.projectdata.v1.RfiEntityObservation");
_define_property(RfiEntityObservation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "first_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "last_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "cage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "org_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "employer_hint",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RegistryRef
 */ export class RegistryRef extends Message {
    static fromBinary(bytes, options) {
        return new RegistryRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegistryRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegistryRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegistryRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string registry_id = 2;
   */ _define_property(this, "registryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegistryRef, "runtime", proto3);
_define_property(RegistryRef, "typeName", "mono.projectdata.v1.RegistryRef");
_define_property(RegistryRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiEntity
 */ export class RfiEntity extends Message {
    static fromBinary(bytes, options) {
        return new RfiEntity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEntity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEntity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEntity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string link_id = 1;
   */ _define_property(this, "linkId", ""), /**
   * @generated from field: string role = 2;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string target_kind = 3;
   */ _define_property(this, "targetKind", ""), /**
   * effective (candidate decision + merges followed); "" while pending
   *
   * @generated from field: string registry_id = 4;
   */ _define_property(this, "registryId", ""), /**
   * read time from the registry; "" when restricted
   *
   * @generated from field: string label = 5;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string sublabel = 6;
   */ _define_property(this, "sublabel", ""), /**
   * @generated from field: string href = 7;
   */ _define_property(this, "href", ""), /**
   * linked | pending | ambiguous | restricted
   *
   * @generated from field: string state = 8;
   */ _define_property(this, "state", ""), /**
   * @generated from field: bool restricted = 9;
   */ _define_property(this, "restricted", false), /**
   * @generated from field: string source = 10;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_ref = 11;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: string resolution_basis = 12;
   */ _define_property(this, "resolutionBasis", ""), /**
   * @generated from field: int32 position = 13;
   */ _define_property(this, "position", 0), /**
   * from REG-54's candidate payload
   *
   * @generated from field: string candidate_id = 14;
   */ _define_property(this, "candidateId", ""), /**
   * @generated from field: string pending_label = 15;
   */ _define_property(this, "pendingLabel", ""), /**
   * @generated from field: string pending_context = 16;
   */ _define_property(this, "pendingContext", ""), /**
   * candidate_ids, labelled; empty when linked
   *
   * @generated from field: repeated mono.projectdata.v1.RfiEntityOption options = 17;
   */ _define_property(this, "options", []), /**
   * a shared _system gov org (M/000019)
   *
   * @generated from field: bool system = 18;
   */ _define_property(this, "system", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEntity, "runtime", proto3);
_define_property(RfiEntity, "typeName", "mono.projectdata.v1.RfiEntity");
_define_property(RfiEntity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sublabel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "restricted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "resolution_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "position",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "pending_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "pending_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "options",
            kind: "message",
            T: RfiEntityOption,
            repeated: true
        },
        {
            no: 18,
            name: "system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiEntityOption
 */ export class RfiEntityOption extends Message {
    static fromBinary(bytes, options) {
        return new RfiEntityOption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiEntityOption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiEntityOption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiEntityOption, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string registry_id = 1;
   */ _define_property(this, "registryId", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string sublabel = 3;
   */ _define_property(this, "sublabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiEntityOption, "runtime", proto3);
_define_property(RfiEntityOption, "typeName", "mono.projectdata.v1.RfiEntityOption");
_define_property(RfiEntityOption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sublabel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiEntitiesRequest
 */ export class ListRfiEntitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiEntitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiEntitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiEntitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiEntitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * empty = all
   *
   * @generated from field: repeated string roles = 2;
   */ _define_property(this, "roles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiEntitiesRequest, "runtime", proto3);
_define_property(ListRfiEntitiesRequest, "typeName", "mono.projectdata.v1.ListRfiEntitiesRequest");
_define_property(ListRfiEntitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiEntitiesResponse
 */ export class ListRfiEntitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiEntitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiEntitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiEntitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiEntitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiEntity entities = 1;
   */ _define_property(this, "entities", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiEntitiesResponse, "runtime", proto3);
_define_property(ListRfiEntitiesResponse, "typeName", "mono.projectdata.v1.ListRfiEntitiesResponse");
_define_property(ListRfiEntitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entities",
            kind: "message",
            T: RfiEntity,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkRfiEntityRequest
 */ export class LinkRfiEntityRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkRfiEntityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRfiEntityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRfiEntityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRfiEntityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string role = 2;
   */ _define_property(this, "role", ""), /**
   * @generated from oneof mono.projectdata.v1.LinkRfiEntityRequest.target
   */ _define_property(this, "target", {
            case: undefined
        }), /**
   * user | notice | assist   (signal / extraction are server-only)
   *
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_ref = 6;
   */ _define_property(this, "sourceRef", ""), /**
   * @generated from field: int32 position = 7;
   */ _define_property(this, "position", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRfiEntityRequest, "runtime", proto3);
_define_property(LinkRfiEntityRequest, "typeName", "mono.projectdata.v1.LinkRfiEntityRequest");
_define_property(LinkRfiEntityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "registry_ref",
            kind: "message",
            T: RegistryRef,
            oneof: "target"
        },
        {
            no: 4,
            name: "observation",
            kind: "message",
            T: RfiEntityObservation,
            oneof: "target"
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "position",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LinkRfiEntityResponse
 */ export class LinkRfiEntityResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkRfiEntityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkRfiEntityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkRfiEntityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkRfiEntityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiEntity entity = 1;
   */ _define_property(this, "entity", void 0), /**
   * MATCHED|CREATED|CANDIDATE|AMBIGUOUS|PICKED
   *
   * @generated from field: string resolution_status = 2;
   */ _define_property(this, "resolutionStatus", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkRfiEntityResponse, "runtime", proto3);
_define_property(LinkRfiEntityResponse, "typeName", "mono.projectdata.v1.LinkRfiEntityResponse");
_define_property(LinkRfiEntityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entity",
            kind: "message",
            T: RfiEntity
        },
        {
            no: 2,
            name: "resolution_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConfirmRfiEntityRequest
 */ export class ConfirmRfiEntityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ConfirmRfiEntityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmRfiEntityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmRfiEntityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmRfiEntityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string link_id = 2;
   */ _define_property(this, "linkId", ""), /**
   * link | create | dismiss
   *
   * @generated from field: string decision = 3;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string registry_id = 4;
   */ _define_property(this, "registryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConfirmRfiEntityRequest, "runtime", proto3);
_define_property(ConfirmRfiEntityRequest, "typeName", "mono.projectdata.v1.ConfirmRfiEntityRequest");
_define_property(ConfirmRfiEntityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "registry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ConfirmRfiEntityResponse
 */ export class ConfirmRfiEntityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ConfirmRfiEntityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConfirmRfiEntityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConfirmRfiEntityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConfirmRfiEntityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiEntity entity = 1;
   */ _define_property(this, "entity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ConfirmRfiEntityResponse, "runtime", proto3);
_define_property(ConfirmRfiEntityResponse, "typeName", "mono.projectdata.v1.ConfirmRfiEntityResponse");
_define_property(ConfirmRfiEntityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "entity",
            kind: "message",
            T: RfiEntity
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkRfiEntityRequest
 */ export class UnlinkRfiEntityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRfiEntityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRfiEntityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRfiEntityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRfiEntityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string link_id = 2;
   */ _define_property(this, "linkId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRfiEntityRequest, "runtime", proto3);
_define_property(UnlinkRfiEntityRequest, "typeName", "mono.projectdata.v1.UnlinkRfiEntityRequest");
_define_property(UnlinkRfiEntityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnlinkRfiEntityResponse
 */ export class UnlinkRfiEntityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkRfiEntityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkRfiEntityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkRfiEntityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkRfiEntityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkRfiEntityResponse, "runtime", proto3);
_define_property(UnlinkRfiEntityResponse, "typeName", "mono.projectdata.v1.UnlinkRfiEntityResponse");
_define_property(UnlinkRfiEntityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.RfiHomeLinkedPursuit
 */ export class RfiHomeLinkedPursuit extends Message {
    static fromBinary(bytes, options) {
        return new RfiHomeLinkedPursuit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiHomeLinkedPursuit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiHomeLinkedPursuit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiHomeLinkedPursuit, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: bool primary = 3;
   */ _define_property(this, "primary", false), /**
   * @generated from field: repeated int32 question_numbers = 4;
   */ _define_property(this, "questionNumbers", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiHomeLinkedPursuit, "runtime", proto3);
_define_property(RfiHomeLinkedPursuit, "typeName", "mono.projectdata.v1.RfiHomeLinkedPursuit");
_define_property(RfiHomeLinkedPursuit, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "question_numbers",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiHomeNotice
 */ export class RfiHomeNotice extends Message {
    static fromBinary(bytes, options) {
        return new RfiHomeNotice().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiHomeNotice().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiHomeNotice().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiHomeNotice, a, b);
    }
    constructor(data){
        super(), /**
   * v2.3 (D-SOR 4): *_name / *_label / point_of_contact_email are the morgans
   * notice's public text, read live and never stored; when the matching *_ref
   * is set the page shows the registry label from `entities` instead.
   *
   * @generated from field: string notice_id = 1;
   */ _define_property(this, "noticeId", ""), /**
   * @generated from field: string type_label = 2;
   */ _define_property(this, "typeLabel", ""), /**
   * @generated from field: string office_name = 3;
   */ _define_property(this, "officeName", ""), /**
   * @generated from field: string office_ref = 4;
   */ _define_property(this, "officeRef", ""), /**
   * @generated from field: string vehicle_label = 5;
   */ _define_property(this, "vehicleLabel", ""), /**
   * @generated from field: string vehicle_ref = 6;
   */ _define_property(this, "vehicleRef", ""), /**
   * @generated from field: google.protobuf.Timestamp posted_at = 7;
   */ _define_property(this, "postedAt", void 0), /**
   * @generated from field: string point_of_contact_name = 8;
   */ _define_property(this, "pointOfContactName", ""), /**
   * @generated from field: string point_of_contact_ref = 9;
   */ _define_property(this, "pointOfContactRef", ""), /**
   * v2.3: inputs for "Add to this RFI"
   *
   * @generated from field: string point_of_contact_email = 10;
   */ _define_property(this, "pointOfContactEmail", ""), /**
   * @generated from field: string office_code = 11;
   */ _define_property(this, "officeCode", ""), /**
   * @generated from field: string vehicle_contract_number = 12;
   */ _define_property(this, "vehicleContractNumber", ""), /**
   * v2.3: "link" | "match" | ""
   *
   * @generated from field: string office_ref_source = 13;
   */ _define_property(this, "officeRefSource", ""), /**
   * @generated from field: string vehicle_ref_source = 14;
   */ _define_property(this, "vehicleRefSource", ""), /**
   * @generated from field: string point_of_contact_ref_source = 15;
   */ _define_property(this, "pointOfContactRefSource", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiHomeNotice, "runtime", proto3);
_define_property(RfiHomeNotice, "typeName", "mono.projectdata.v1.RfiHomeNotice");
_define_property(RfiHomeNotice, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "office_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "office_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "vehicle_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "vehicle_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "posted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "point_of_contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "point_of_contact_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "point_of_contact_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "office_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "vehicle_contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "office_ref_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "vehicle_ref_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "point_of_contact_ref_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiWorkspaceHomeResponse
 */ export class GetRfiWorkspaceHomeResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiWorkspaceHomeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiWorkspaceHomeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiWorkspaceHomeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiWorkspaceHomeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp response_due = 3;
   */ _define_property(this, "responseDue", void 0), /**
   * @generated from field: int32 question_count = 4;
   */ _define_property(this, "questionCount", 0), /**
   * "VA asked 12 questions; answers feed the OMEGA proposal later"
   *
   * @generated from field: string subtitle_note = 5;
   */ _define_property(this, "subtitleNote", ""), /**
   * @generated from field: mono.projectdata.v1.RfiHomeKpis kpis = 6;
   */ _define_property(this, "kpis", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.RfiHomeQuestionRow questions = 7;
   */ _define_property(this, "questions", []), /**
   * @generated from field: repeated mono.projectdata.v1.RfiHomeSignal signals = 8;
   */ _define_property(this, "signals", []), /**
   * @generated from field: mono.projectdata.v1.RfiHomeNotice notice = 9;
   */ _define_property(this, "notice", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.RfiHomeLinkedPursuit linked_pursuits = 10;
   */ _define_property(this, "linkedPursuits", []), /**
   * @generated from field: string submission_format = 11;
   */ _define_property(this, "submissionFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp questions_due = 13;
   */ _define_property(this, "questionsDue", void 0), /**
   * @generated from field: bool can_edit = 14;
   */ _define_property(this, "canEdit", false), /**
   * @generated from field: bool can_record_submission = 15;
   */ _define_property(this, "canRecordSubmission", false), /**
   * v2.1: "docx" | "pdf"; derived from submission_format; WRT-16 preselects it
   *
   * @generated from field: string preferred_package_format = 16;
   */ _define_property(this, "preferredPackageFormat", ""), /**
   * v2.3: ListRfiEntities, all roles, in the same call (rail + notice refs)
   *
   * @generated from field: repeated mono.projectdata.v1.RfiEntity entities = 17;
   */ _define_property(this, "entities", []), /**
   * facts the Edit dialog needs
   *
   * @generated from field: int32 word_limit = 18;
   */ _define_property(this, "wordLimit", 0), /**
   * @generated from field: int32 words_per_page = 19;
   */ _define_property(this, "wordsPerPage", 0), /**
   * short agency name used in copy ("VA"; "The agency" when unknown)
   *
   * @generated from field: string agency_short = 20;
   */ _define_property(this, "agencyShort", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiWorkspaceHomeResponse, "runtime", proto3);
_define_property(GetRfiWorkspaceHomeResponse, "typeName", "mono.projectdata.v1.GetRfiWorkspaceHomeResponse");
_define_property(GetRfiWorkspaceHomeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "response_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "question_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "subtitle_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "kpis",
            kind: "message",
            T: RfiHomeKpis
        },
        {
            no: 7,
            name: "questions",
            kind: "message",
            T: RfiHomeQuestionRow,
            repeated: true
        },
        {
            no: 8,
            name: "signals",
            kind: "message",
            T: RfiHomeSignal,
            repeated: true
        },
        {
            no: 9,
            name: "notice",
            kind: "message",
            T: RfiHomeNotice
        },
        {
            no: 10,
            name: "linked_pursuits",
            kind: "message",
            T: RfiHomeLinkedPursuit,
            repeated: true
        },
        {
            no: 11,
            name: "submission_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "questions_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "can_edit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "can_record_submission",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 16,
            name: "preferred_package_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "entities",
            kind: "message",
            T: RfiEntity,
            repeated: true
        },
        {
            no: 18,
            name: "word_limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "words_per_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 20,
            name: "agency_short",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiSubmissionFactsRequest
 */ export class UpdateRfiSubmissionFactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiSubmissionFactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiSubmissionFactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiSubmissionFactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiSubmissionFactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: double page_limit = 2;
   */ _define_property(this, "pageLimit", 0), /**
   * @generated from field: int32 word_limit = 3;
   */ _define_property(this, "wordLimit", 0), /**
   * @generated from field: int32 words_per_page = 4;
   */ _define_property(this, "wordsPerPage", 0), /**
   * @generated from field: string submission_format = 5;
   */ _define_property(this, "submissionFormat", ""), /**
   * @generated from field: google.protobuf.Timestamp questions_due = 7;
   */ _define_property(this, "questionsDue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiSubmissionFactsRequest, "runtime", proto3);
_define_property(UpdateRfiSubmissionFactsRequest, "typeName", "mono.projectdata.v1.UpdateRfiSubmissionFactsRequest");
_define_property(UpdateRfiSubmissionFactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "page_limit",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 3,
            name: "word_limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "words_per_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "submission_format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "questions_due",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiSubmissionFactsResponse
 */ export class UpdateRfiSubmissionFactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiSubmissionFactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiSubmissionFactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiSubmissionFactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiSubmissionFactsResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiSubmissionFactsResponse, "runtime", proto3);
_define_property(UpdateRfiSubmissionFactsResponse, "typeName", "mono.projectdata.v1.UpdateRfiSubmissionFactsResponse");
_define_property(UpdateRfiSubmissionFactsResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.SetRfiQuestionPursuitScopeRequest
 */ export class SetRfiQuestionPursuitScopeRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetRfiQuestionPursuitScopeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetRfiQuestionPursuitScopeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetRfiQuestionPursuitScopeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetRfiQuestionPursuitScopeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string question_id = 2;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: bool remove = 4;
   */ _define_property(this, "remove", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetRfiQuestionPursuitScopeRequest, "runtime", proto3);
_define_property(SetRfiQuestionPursuitScopeRequest, "typeName", "mono.projectdata.v1.SetRfiQuestionPursuitScopeRequest");
_define_property(SetRfiQuestionPursuitScopeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "remove",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetRfiQuestionPursuitScopeResponse
 */ export class SetRfiQuestionPursuitScopeResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetRfiQuestionPursuitScopeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetRfiQuestionPursuitScopeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetRfiQuestionPursuitScopeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetRfiQuestionPursuitScopeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiHomeSignal created_signal = 1;
   */ _define_property(this, "createdSignal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetRfiQuestionPursuitScopeResponse, "runtime", proto3);
_define_property(SetRfiQuestionPursuitScopeResponse, "typeName", "mono.projectdata.v1.SetRfiQuestionPursuitScopeResponse");
_define_property(SetRfiQuestionPursuitScopeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "created_signal",
            kind: "message",
            T: RfiHomeSignal
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiSignalRequest
 */ export class CreateRfiSignalRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiSignalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiSignalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiSignalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiSignalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * v2.3: "{{n}}" placeholders; renamed from body (same field number, same type)
   *
   * @generated from field: string body_template = 3;
   */ _define_property(this, "bodyTemplate", ""), /**
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string status_label = 6;
   */ _define_property(this, "statusLabel", ""), /**
   * @generated from field: string review_href = 7;
   */ _define_property(this, "reviewHref", ""), /**
   * v2.3
   *
   * @generated from field: repeated mono.projectdata.v1.RfiSignalLinkInput links = 8;
   */ _define_property(this, "links", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiSignalRequest, "runtime", proto3);
_define_property(CreateRfiSignalRequest, "typeName", "mono.projectdata.v1.CreateRfiSignalRequest");
_define_property(CreateRfiSignalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "body_template",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "review_href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "links",
            kind: "message",
            T: RfiSignalLinkInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiSignalLinkInput
 */ export class RfiSignalLinkInput extends Message {
    static fromBinary(bytes, options) {
        return new RfiSignalLinkInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSignalLinkInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSignalLinkInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSignalLinkInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 ordinal = 1;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string link_role = 2;
   */ _define_property(this, "linkRole", ""), /**
   * @generated from field: string target_kind = 3;
   */ _define_property(this, "targetKind", ""), /**
   * registry or context id; empty when observation is set
   *
   * @generated from field: string target_id = 4;
   */ _define_property(this, "targetId", ""), /**
   * ABOUT a person/company/org/vehicle not picked from the registry → ResolveEntities
   *
   * @generated from field: mono.projectdata.v1.RfiEntityObservation observation = 5;
   */ _define_property(this, "observation", void 0), /**
   * v2.3 reconcile: a service-lane caller (DAT-14) passes an already-filed
   * PENDING REG-54 candidate of context RFI.
   *
   * @generated from field: string candidate_id = 6;
   */ _define_property(this, "candidateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSignalLinkInput, "runtime", proto3);
_define_property(RfiSignalLinkInput, "typeName", "mono.projectdata.v1.RfiSignalLinkInput");
_define_property(RfiSignalLinkInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "link_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "target_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "observation",
            kind: "message",
            T: RfiEntityObservation
        },
        {
            no: 6,
            name: "candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiSignalResponse
 */ export class CreateRfiSignalResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiSignalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiSignalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiSignalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiSignalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiHomeSignal signal = 1;
   */ _define_property(this, "signal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiSignalResponse, "runtime", proto3);
_define_property(CreateRfiSignalResponse, "typeName", "mono.projectdata.v1.CreateRfiSignalResponse");
_define_property(CreateRfiSignalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "signal",
            kind: "message",
            T: RfiHomeSignal
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RetractRfiSignalRequest
 */ export class RetractRfiSignalRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetractRfiSignalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetractRfiSignalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetractRfiSignalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetractRfiSignalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string signal_id = 2;
   */ _define_property(this, "signalId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetractRfiSignalRequest, "runtime", proto3);
_define_property(RetractRfiSignalRequest, "typeName", "mono.projectdata.v1.RetractRfiSignalRequest");
_define_property(RetractRfiSignalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "signal_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RetractRfiSignalResponse
 */ export class RetractRfiSignalResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetractRfiSignalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetractRfiSignalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetractRfiSignalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetractRfiSignalResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetractRfiSignalResponse, "runtime", proto3);
_define_property(RetractRfiSignalResponse, "typeName", "mono.projectdata.v1.RetractRfiSignalResponse");
_define_property(RetractRfiSignalResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.RfiSectionView
 */ export class RfiSectionView extends Message {
    static fromBinary(bytes, options) {
        return new RfiSectionView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSectionView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSectionView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSectionView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * Empty for a top-level section.
   *
   * @generated from field: string parent_section_id = 3;
   */ _define_property(this, "parentSectionId", ""), /**
   * @generated from field: int32 position = 4;
   */ _define_property(this, "position", 0), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string owner_user_id = 6;
   */ _define_property(this, "ownerUserId", ""), /**
   * Empty when none. May equal owner_user_id.
   *
   * @generated from field: string reviewer_user_id = 7;
   */ _define_property(this, "reviewerUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp internal_due = 8;
   */ _define_property(this, "internalDue", void 0), /**
   * "not_started" | "in_progress" | "complete"
   *
   * @generated from field: string work_state = 9;
   */ _define_property(this, "workState", ""), /**
   * "not_requested" | "pending" | "approved" | "changes_requested"
   *
   * @generated from field: string review_state = 10;
   */ _define_property(this, "reviewState", ""), /**
   * @generated from field: string created_by = 11;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */ _define_property(this, "updatedAt", void 0), /**
   * WRT-29: the section's anchor in the response document and its content
   * projection (inputs to the question status).
   *
   * @generated from field: string anchor_bookmark = 14;
   */ _define_property(this, "anchorBookmark", ""), /**
   * @generated from field: google.protobuf.Timestamp orphaned_at = 15;
   */ _define_property(this, "orphanedAt", void 0), /**
   * @generated from field: int32 content_words = 16;
   */ _define_property(this, "contentWords", 0), /**
   * @generated from field: string content_region_sha256 = 17;
   */ _define_property(this, "contentRegionSha256", ""), /**
   * WRT-05: "answer" | "capability_statement" | "other"
   *
   * @generated from field: string role = 18;
   */ _define_property(this, "role", ""), /**
   * WRT-05: "manual" | "question_seed" | "document_heading"
   *
   * @generated from field: string origin = 19;
   */ _define_property(this, "origin", ""), /**
   * WRT-05: JSON object ("{}" = nothing)
   *
   * @generated from field: string starts_from_json = 20;
   */ _define_property(this, "startsFromJson", ""), /**
   * WRT-16: the approved answer (final_text is not sent here; past answers
   * read it server-side).
   *
   * @generated from field: string final_version_id = 21;
   */ _define_property(this, "finalVersionId", ""), /**
   * @generated from field: string final_region_sha256 = 22;
   */ _define_property(this, "finalRegionSha256", ""), /**
   * @generated from field: string finalized_by = 23;
   */ _define_property(this, "finalizedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp finalized_at = 24;
   */ _define_property(this, "finalizedAt", void 0), /**
   * WRT-16: derived rfiQuestionStatus: not_started | drafting | in_review |
   * final | final_edited | orphaned (§3.6).
   *
   * @generated from field: string question_status = 25;
   */ _define_property(this, "questionStatus", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSectionView, "runtime", proto3);
_define_property(RfiSectionView, "typeName", "mono.projectdata.v1.RfiSectionView");
_define_property(RfiSectionView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "position",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reviewer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "internal_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "work_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "review_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "anchor_bookmark",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "orphaned_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "content_words",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "content_region_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "starts_from_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "final_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "final_region_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "finalized_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "finalized_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "question_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiSectionEventView
 */ export class RfiSectionEventView extends Message {
    static fromBinary(bytes, options) {
        return new RfiSectionEventView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiSectionEventView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiSectionEventView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiSectionEventView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * "created" | "renamed" | "moved" | "work_state" | "review_state" |
   * "assigned" | "due" | "removed"
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string before_json = 4;
   */ _define_property(this, "beforeJson", ""), /**
   * @generated from field: string after_json = 5;
   */ _define_property(this, "afterJson", ""), /**
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiSectionEventView, "runtime", proto3);
_define_property(RfiSectionEventView, "typeName", "mono.projectdata.v1.RfiSectionEventView");
_define_property(RfiSectionEventView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "before_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "after_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * A question still mapped to a removed section and so no longer addressed.
 *
 * @generated from message mono.projectdata.v1.RfiUnaddressedQuestionRef
 */ export class RfiUnaddressedQuestionRef extends Message {
    static fromBinary(bytes, options) {
        return new RfiUnaddressedQuestionRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiUnaddressedQuestionRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiUnaddressedQuestionRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiUnaddressedQuestionRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_id = 1;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string question_ref = 2;
   */ _define_property(this, "questionRef", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiUnaddressedQuestionRef, "runtime", proto3);
_define_property(RfiUnaddressedQuestionRef, "typeName", "mono.projectdata.v1.RfiUnaddressedQuestionRef");
_define_property(RfiUnaddressedQuestionRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiFollowUpView
 */ export class RfiFollowUpView extends Message {
    static fromBinary(bytes, options) {
        return new RfiFollowUpView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiFollowUpView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiFollowUpView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiFollowUpView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", ""), /**
   * Set only when the follow-up was explicitly raised against a linked Pursuit.
   *
   * @generated from field: string capture_project_id = 4;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string assignee_user_id = 6;
   */ _define_property(this, "assigneeUserId", ""), /**
   * "open" | "done"
   *
   * @generated from field: string status = 7;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 11;
   */ _define_property(this, "resolvedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiFollowUpView, "runtime", proto3);
_define_property(RfiFollowUpView, "typeName", "mono.projectdata.v1.RfiFollowUpView");
_define_property(RfiFollowUpView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "assignee_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSectionsRequest
 */ export class ListRfiSectionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSectionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSectionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSectionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSectionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSectionsRequest, "runtime", proto3);
_define_property(ListRfiSectionsRequest, "typeName", "mono.projectdata.v1.ListRfiSectionsRequest");
_define_property(ListRfiSectionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSectionsResponse
 */ export class ListRfiSectionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSectionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSectionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSectionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSectionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Parent-first: top level by position, then each level by position.
   *
   * @generated from field: repeated mono.projectdata.v1.RfiSectionView sections = 1;
   */ _define_property(this, "sections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSectionsResponse, "runtime", proto3);
_define_property(ListRfiSectionsResponse, "typeName", "mono.projectdata.v1.ListRfiSectionsResponse");
_define_property(ListRfiSectionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sections",
            kind: "message",
            T: RfiSectionView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiSectionRequest
 */ export class CreateRfiSectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiSectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiSectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiSectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiSectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string parent_section_id = 2;
   */ _define_property(this, "parentSectionId", ""), /**
   * < 0 or past the end appends.
   *
   * @generated from field: int32 position = 3;
   */ _define_property(this, "position", 0), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string owner_user_id = 5;
   */ _define_property(this, "ownerUserId", ""), /**
   * @generated from field: string reviewer_user_id = 6;
   */ _define_property(this, "reviewerUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp internal_due = 7;
   */ _define_property(this, "internalDue", void 0), /**
   * WRT-07: "answer" (default) | "other"; the capability statement is created by
   * EnsureRfiCapabilityStatement only.
   *
   * @generated from field: string role = 8;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiSectionRequest, "runtime", proto3);
_define_property(CreateRfiSectionRequest, "typeName", "mono.projectdata.v1.CreateRfiSectionRequest");
_define_property(CreateRfiSectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "position",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reviewer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "internal_due",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiSectionResponse
 */ export class CreateRfiSectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiSectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiSectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiSectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiSectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiSectionView section = 1;
   */ _define_property(this, "section", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiSectionResponse, "runtime", proto3);
_define_property(CreateRfiSectionResponse, "typeName", "mono.projectdata.v1.CreateRfiSectionResponse");
_define_property(CreateRfiSectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: RfiSectionView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiSectionRequest
 */ export class UpdateRfiSectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiSectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiSectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiSectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiSectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: optional string title = 3;
   */ _define_property(this, "title", void 0), /**
   * @generated from field: optional string owner_user_id = 4;
   */ _define_property(this, "ownerUserId", void 0), /**
   * @generated from field: optional string reviewer_user_id = 5;
   */ _define_property(this, "reviewerUserId", void 0), /**
   * @generated from field: bool clear_reviewer = 6;
   */ _define_property(this, "clearReviewer", false), /**
   * @generated from field: optional google.protobuf.Timestamp internal_due = 7;
   */ _define_property(this, "internalDue", void 0), /**
   * @generated from field: bool clear_internal_due = 8;
   */ _define_property(this, "clearInternalDue", false), /**
   * @generated from field: optional string work_state = 9;
   */ _define_property(this, "workState", void 0), /**
   * @generated from field: optional string review_state = 10;
   */ _define_property(this, "reviewState", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiSectionRequest, "runtime", proto3);
_define_property(UpdateRfiSectionRequest, "typeName", "mono.projectdata.v1.UpdateRfiSectionRequest");
_define_property(UpdateRfiSectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 4,
            name: "owner_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "reviewer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "clear_reviewer",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "internal_due",
            kind: "message",
            T: Timestamp,
            opt: true
        },
        {
            no: 8,
            name: "clear_internal_due",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "work_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 10,
            name: "review_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiSectionResponse
 */ export class UpdateRfiSectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiSectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiSectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiSectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiSectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiSectionView section = 1;
   */ _define_property(this, "section", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiSectionResponse, "runtime", proto3);
_define_property(UpdateRfiSectionResponse, "typeName", "mono.projectdata.v1.UpdateRfiSectionResponse");
_define_property(UpdateRfiSectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: RfiSectionView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MoveRfiSectionRequest
 */ export class MoveRfiSectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new MoveRfiSectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveRfiSectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveRfiSectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveRfiSectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * Empty moves to the top level.
   *
   * @generated from field: string parent_section_id = 3;
   */ _define_property(this, "parentSectionId", ""), /**
   * < 0 or past the end places last.
   *
   * @generated from field: int32 position = 4;
   */ _define_property(this, "position", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveRfiSectionRequest, "runtime", proto3);
_define_property(MoveRfiSectionRequest, "typeName", "mono.projectdata.v1.MoveRfiSectionRequest");
_define_property(MoveRfiSectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "parent_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "position",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.MoveRfiSectionResponse
 */ export class MoveRfiSectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new MoveRfiSectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveRfiSectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveRfiSectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveRfiSectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiSectionView section = 1;
   */ _define_property(this, "section", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveRfiSectionResponse, "runtime", proto3);
_define_property(MoveRfiSectionResponse, "typeName", "mono.projectdata.v1.MoveRfiSectionResponse");
_define_property(MoveRfiSectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: RfiSectionView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveRfiSectionRequest
 */ export class RemoveRfiSectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveRfiSectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveRfiSectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveRfiSectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveRfiSectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * Required to remove a section that still has active question mappings.
   *
   * @generated from field: bool confirm = 3;
   */ _define_property(this, "confirm", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveRfiSectionRequest, "runtime", proto3);
_define_property(RemoveRfiSectionRequest, "typeName", "mono.projectdata.v1.RemoveRfiSectionRequest");
_define_property(RemoveRfiSectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "confirm",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveRfiSectionResponse
 */ export class RemoveRfiSectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveRfiSectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveRfiSectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveRfiSectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveRfiSectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool removed = 1;
   */ _define_property(this, "removed", false), /**
   * Set when the section was NOT removed because confirm was false and
   * questions are still mapped to it.
   *
   * @generated from field: string warning = 2;
   */ _define_property(this, "warning", ""), /**
   * @generated from field: repeated mono.projectdata.v1.RfiUnaddressedQuestionRef unaddressed_questions = 3;
   */ _define_property(this, "unaddressedQuestions", []), /**
   * @generated from field: int32 unaddressed_count = 4;
   */ _define_property(this, "unaddressedCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveRfiSectionResponse, "runtime", proto3);
_define_property(RemoveRfiSectionResponse, "typeName", "mono.projectdata.v1.RemoveRfiSectionResponse");
_define_property(RemoveRfiSectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "warning",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "unaddressed_questions",
            kind: "message",
            T: RfiUnaddressedQuestionRef,
            repeated: true
        },
        {
            no: 4,
            name: "unaddressed_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSectionEventsRequest
 */ export class ListRfiSectionEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSectionEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSectionEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSectionEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSectionEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * Optional; empty lists the whole RFI's history.
   *
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSectionEventsRequest, "runtime", proto3);
_define_property(ListRfiSectionEventsRequest, "typeName", "mono.projectdata.v1.ListRfiSectionEventsRequest");
_define_property(ListRfiSectionEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSectionEventsResponse
 */ export class ListRfiSectionEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSectionEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSectionEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSectionEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSectionEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Oldest first.
   *
   * @generated from field: repeated mono.projectdata.v1.RfiSectionEventView events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSectionEventsResponse, "runtime", proto3);
_define_property(ListRfiSectionEventsResponse, "typeName", "mono.projectdata.v1.ListRfiSectionEventsResponse");
_define_property(ListRfiSectionEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: RfiSectionEventView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiFollowUpRequest
 */ export class CreateRfiFollowUpRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiFollowUpRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiFollowUpRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiFollowUpRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiFollowUpRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * Only for an explicit Pursuit action; must be linked to this RFI.
   *
   * @generated from field: string capture_project_id = 3;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string assignee_user_id = 5;
   */ _define_property(this, "assigneeUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiFollowUpRequest, "runtime", proto3);
_define_property(CreateRfiFollowUpRequest, "typeName", "mono.projectdata.v1.CreateRfiFollowUpRequest");
_define_property(CreateRfiFollowUpRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "assignee_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiFollowUpResponse
 */ export class CreateRfiFollowUpResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiFollowUpResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiFollowUpResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiFollowUpResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiFollowUpResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiFollowUpView follow_up = 1;
   */ _define_property(this, "followUp", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiFollowUpResponse, "runtime", proto3);
_define_property(CreateRfiFollowUpResponse, "typeName", "mono.projectdata.v1.CreateRfiFollowUpResponse");
_define_property(CreateRfiFollowUpResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "follow_up",
            kind: "message",
            T: RfiFollowUpView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiFollowUpsRequest
 */ export class ListRfiFollowUpsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiFollowUpsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiFollowUpsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiFollowUpsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiFollowUpsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * Optional filters.
   *
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiFollowUpsRequest, "runtime", proto3);
_define_property(ListRfiFollowUpsRequest, "typeName", "mono.projectdata.v1.ListRfiFollowUpsRequest");
_define_property(ListRfiFollowUpsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiFollowUpsResponse
 */ export class ListRfiFollowUpsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiFollowUpsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiFollowUpsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiFollowUpsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiFollowUpsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiFollowUpView follow_ups = 1;
   */ _define_property(this, "followUps", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiFollowUpsResponse, "runtime", proto3);
_define_property(ListRfiFollowUpsResponse, "typeName", "mono.projectdata.v1.ListRfiFollowUpsResponse");
_define_property(ListRfiFollowUpsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "follow_ups",
            kind: "message",
            T: RfiFollowUpView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiFollowUpRequest
 */ export class UpdateRfiFollowUpRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiFollowUpRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiFollowUpRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiFollowUpRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiFollowUpRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string follow_up_id = 2;
   */ _define_property(this, "followUpId", ""), /**
   * @generated from field: optional string title = 3;
   */ _define_property(this, "title", void 0), /**
   * @generated from field: optional string assignee_user_id = 4;
   */ _define_property(this, "assigneeUserId", void 0), /**
   * "open" | "done"
   *
   * @generated from field: optional string status = 5;
   */ _define_property(this, "status", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiFollowUpRequest, "runtime", proto3);
_define_property(UpdateRfiFollowUpRequest, "typeName", "mono.projectdata.v1.UpdateRfiFollowUpRequest");
_define_property(UpdateRfiFollowUpRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "follow_up_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 4,
            name: "assignee_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiFollowUpResponse
 */ export class UpdateRfiFollowUpResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiFollowUpResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiFollowUpResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiFollowUpResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiFollowUpResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiFollowUpView follow_up = 1;
   */ _define_property(this, "followUp", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiFollowUpResponse, "runtime", proto3);
_define_property(UpdateRfiFollowUpResponse, "typeName", "mono.projectdata.v1.UpdateRfiFollowUpResponse");
_define_property(UpdateRfiFollowUpResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "follow_up",
            kind: "message",
            T: RfiFollowUpView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiSectionDocumentRequest
 */ export class CreateRfiSectionDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiSectionDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiSectionDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiSectionDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiSectionDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiSectionDocumentRequest, "runtime", proto3);
_define_property(CreateRfiSectionDocumentRequest, "typeName", "mono.projectdata.v1.CreateRfiSectionDocumentRequest");
_define_property(CreateRfiSectionDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiSectionDocumentResponse
 */ export class CreateRfiSectionDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiSectionDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiSectionDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiSectionDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiSectionDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiSectionDocumentSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiSectionDocumentResponse, "runtime", proto3);
_define_property(CreateRfiSectionDocumentResponse, "typeName", "mono.projectdata.v1.CreateRfiSectionDocumentResponse");
_define_property(CreateRfiSectionDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: RfiSectionDocumentSnapshot
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReadRfiSectionDocumentRequest
 */ export class ReadRfiSectionDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReadRfiSectionDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadRfiSectionDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadRfiSectionDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadRfiSectionDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * empty reads current
   *
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadRfiSectionDocumentRequest, "runtime", proto3);
_define_property(ReadRfiSectionDocumentRequest, "typeName", "mono.projectdata.v1.ReadRfiSectionDocumentRequest");
_define_property(ReadRfiSectionDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReadRfiSectionDocumentResponse
 */ export class ReadRfiSectionDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReadRfiSectionDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReadRfiSectionDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReadRfiSectionDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReadRfiSectionDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiSectionDocumentSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReadRfiSectionDocumentResponse, "runtime", proto3);
_define_property(ReadRfiSectionDocumentResponse, "typeName", "mono.projectdata.v1.ReadRfiSectionDocumentResponse");
_define_property(ReadRfiSectionDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: RfiSectionDocumentSnapshot
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveRfiSectionDocumentRequest
 */ export class SaveRfiSectionDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveRfiSectionDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveRfiSectionDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveRfiSectionDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveRfiSectionDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string base_version_id = 3;
   */ _define_property(this, "baseVersionId", ""), /**
   * DOCX binary
   *
   * @generated from field: bytes content = 4;
   */ _define_property(this, "content", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveRfiSectionDocumentRequest, "runtime", proto3);
_define_property(SaveRfiSectionDocumentRequest, "typeName", "mono.projectdata.v1.SaveRfiSectionDocumentRequest");
_define_property(SaveRfiSectionDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveRfiSectionDocumentResponse
 */ export class SaveRfiSectionDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveRfiSectionDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveRfiSectionDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveRfiSectionDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveRfiSectionDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiSectionDocumentSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveRfiSectionDocumentResponse, "runtime", proto3);
_define_property(SaveRfiSectionDocumentResponse, "typeName", "mono.projectdata.v1.SaveRfiSectionDocumentResponse");
_define_property(SaveRfiSectionDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: RfiSectionDocumentSnapshot
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSectionDocumentHistoryRequest
 */ export class ListRfiSectionDocumentHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSectionDocumentHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSectionDocumentHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSectionDocumentHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSectionDocumentHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSectionDocumentHistoryRequest, "runtime", proto3);
_define_property(ListRfiSectionDocumentHistoryRequest, "typeName", "mono.projectdata.v1.ListRfiSectionDocumentHistoryRequest");
_define_property(ListRfiSectionDocumentHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiSectionDocumentHistoryResponse
 */ export class ListRfiSectionDocumentHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiSectionDocumentHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiSectionDocumentHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiSectionDocumentHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiSectionDocumentHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.ListVersionsResponse history = 1;
   */ _define_property(this, "history", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiSectionDocumentHistoryResponse, "runtime", proto3);
_define_property(ListRfiSectionDocumentHistoryResponse, "typeName", "mono.projectdata.v1.ListRfiSectionDocumentHistoryResponse");
_define_property(ListRfiSectionDocumentHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "history",
            kind: "message",
            T: ListVersionsResponse
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RestoreRfiSectionDocumentRequest
 */ export class RestoreRfiSectionDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new RestoreRfiSectionDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreRfiSectionDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreRfiSectionDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreRfiSectionDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string base_version_id = 3;
   */ _define_property(this, "baseVersionId", ""), /**
   * @generated from field: string origin_version_id = 4;
   */ _define_property(this, "originVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreRfiSectionDocumentRequest, "runtime", proto3);
_define_property(RestoreRfiSectionDocumentRequest, "typeName", "mono.projectdata.v1.RestoreRfiSectionDocumentRequest");
_define_property(RestoreRfiSectionDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "origin_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RestoreRfiSectionDocumentResponse
 */ export class RestoreRfiSectionDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new RestoreRfiSectionDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RestoreRfiSectionDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RestoreRfiSectionDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RestoreRfiSectionDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.docs.v1.RfiSectionDocumentSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RestoreRfiSectionDocumentResponse, "runtime", proto3);
_define_property(RestoreRfiSectionDocumentResponse, "typeName", "mono.projectdata.v1.RestoreRfiSectionDocumentResponse");
_define_property(RestoreRfiSectionDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: RfiSectionDocumentSnapshot
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckRfiSectionDocumentAccessRequest
 */ export class CheckRfiSectionDocumentAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckRfiSectionDocumentAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckRfiSectionDocumentAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckRfiSectionDocumentAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckRfiSectionDocumentAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string action = 3;
   */ _define_property(this, "action", ""), /**
   * WRT-05: with section_id "", the shirohige id of a response document of
   * this RFI; the RFI-level action is checked.
   *
   * @generated from field: string document_id = 4;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckRfiSectionDocumentAccessRequest, "runtime", proto3);
_define_property(CheckRfiSectionDocumentAccessRequest, "typeName", "mono.projectdata.v1.CheckRfiSectionDocumentAccessRequest");
_define_property(CheckRfiSectionDocumentAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CheckRfiSectionDocumentAccessResponse
 */ export class CheckRfiSectionDocumentAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckRfiSectionDocumentAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckRfiSectionDocumentAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckRfiSectionDocumentAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckRfiSectionDocumentAccessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_id = 1;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckRfiSectionDocumentAccessResponse, "runtime", proto3);
_define_property(CheckRfiSectionDocumentAccessResponse, "typeName", "mono.projectdata.v1.CheckRfiSectionDocumentAccessResponse");
_define_property(CheckRfiSectionDocumentAccessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ----- WRT-05: the RFI response document -----
 *
 * @generated from message mono.projectdata.v1.EnsureRfiResponseDocumentRequest
 */ export class EnsureRfiResponseDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new EnsureRfiResponseDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureRfiResponseDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureRfiResponseDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureRfiResponseDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * "" = blank, or the only .docx attachment; "blank" = a blank document
   *
   * @generated from field: string template_attachment_id = 2;
   */ _define_property(this, "templateAttachmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureRfiResponseDocumentRequest, "runtime", proto3);
_define_property(EnsureRfiResponseDocumentRequest, "typeName", "mono.projectdata.v1.EnsureRfiResponseDocumentRequest");
_define_property(EnsureRfiResponseDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureRfiResponseDocumentResponse
 */ export class EnsureRfiResponseDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new EnsureRfiResponseDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureRfiResponseDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureRfiResponseDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureRfiResponseDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string response_document_id = 1;
   */ _define_property(this, "responseDocumentId", ""), /**
   * shirohige document id
   *
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: bool created = 3;
   */ _define_property(this, "created", false), /**
   * @generated from field: int32 headings_inserted = 4;
   */ _define_property(this, "headingsInserted", 0), /**
   * several .docx attachments and no choice yet: nothing was created
   *
   * @generated from field: bool needs_template_choice = 5;
   */ _define_property(this, "needsTemplateChoice", false), /**
   * @generated from field: repeated mono.projectdata.v1.RfiTemplateOption template_options = 6;
   */ _define_property(this, "templateOptions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureRfiResponseDocumentResponse, "runtime", proto3);
_define_property(EnsureRfiResponseDocumentResponse, "typeName", "mono.projectdata.v1.EnsureRfiResponseDocumentResponse");
_define_property(EnsureRfiResponseDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "response_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "headings_inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "needs_template_choice",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "template_options",
            kind: "message",
            T: RfiTemplateOption,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RfiTemplateOption
 */ export class RfiTemplateOption extends Message {
    static fromBinary(bytes, options) {
        return new RfiTemplateOption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiTemplateOption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiTemplateOption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiTemplateOption, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string attachment_id = 1;
   */ _define_property(this, "attachmentId", ""), /**
   * @generated from field: string filename = 2;
   */ _define_property(this, "filename", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiTemplateOption, "runtime", proto3);
_define_property(RfiTemplateOption, "typeName", "mono.projectdata.v1.RfiTemplateOption");
_define_property(RfiTemplateOption, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureRfiAnswerSectionsRequest
 */ export class EnsureRfiAnswerSectionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new EnsureRfiAnswerSectionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureRfiAnswerSectionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureRfiAnswerSectionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureRfiAnswerSectionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureRfiAnswerSectionsRequest, "runtime", proto3);
_define_property(EnsureRfiAnswerSectionsRequest, "typeName", "mono.projectdata.v1.EnsureRfiAnswerSectionsRequest");
_define_property(EnsureRfiAnswerSectionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureRfiAnswerSectionsResponse
 */ export class EnsureRfiAnswerSectionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new EnsureRfiAnswerSectionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureRfiAnswerSectionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureRfiAnswerSectionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureRfiAnswerSectionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 created = 1;
   */ _define_property(this, "created", 0), /**
   * @generated from field: int32 headings_inserted = 2;
   */ _define_property(this, "headingsInserted", 0), /**
   * @generated from field: repeated mono.projectdata.v1.RfiSectionView sections = 3;
   */ _define_property(this, "sections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureRfiAnswerSectionsResponse, "runtime", proto3);
_define_property(EnsureRfiAnswerSectionsResponse, "typeName", "mono.projectdata.v1.EnsureRfiAnswerSectionsResponse");
_define_property(EnsureRfiAnswerSectionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "headings_inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "sections",
            kind: "message",
            T: RfiSectionView,
            repeated: true
        }
    ]));
/**
 * ----- WRT-16: review → final per question region -----
 *
 * @generated from message mono.projectdata.v1.RequestRfiAnswerReviewRequest
 */ export class RequestRfiAnswerReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new RequestRfiAnswerReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestRfiAnswerReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestRfiAnswerReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestRfiAnswerReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * the version the caller saw (informational; the server forcesaves and
   * labels the current version)
   *
   * @generated from field: string base_version_id = 3;
   */ _define_property(this, "baseVersionId", ""), /**
   * optional; must pass read on the RFI
   *
   * @generated from field: string reviewer_user_id = 4;
   */ _define_property(this, "reviewerUserId", ""), /**
   * optional, <= 500 characters
   *
   * @generated from field: string note = 5;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestRfiAnswerReviewRequest, "runtime", proto3);
_define_property(RequestRfiAnswerReviewRequest, "typeName", "mono.projectdata.v1.RequestRfiAnswerReviewRequest");
_define_property(RequestRfiAnswerReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reviewer_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RequestRfiAnswerReviewResponse
 */ export class RequestRfiAnswerReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new RequestRfiAnswerReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestRfiAnswerReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestRfiAnswerReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestRfiAnswerReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiSectionView section = 1;
   */ _define_property(this, "section", void 0), /**
   * the version labelled "Q{n} sent to review"
   *
   * @generated from field: string version_id = 2;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestRfiAnswerReviewResponse, "runtime", proto3);
_define_property(RequestRfiAnswerReviewResponse, "typeName", "mono.projectdata.v1.RequestRfiAnswerReviewResponse");
_define_property(RequestRfiAnswerReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: RfiSectionView
        },
        {
            no: 2,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ApproveRfiAnswerRequest
 */ export class ApproveRfiAnswerRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApproveRfiAnswerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveRfiAnswerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveRfiAnswerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveRfiAnswerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string base_version_id = 3;
   */ _define_property(this, "baseVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveRfiAnswerRequest, "runtime", proto3);
_define_property(ApproveRfiAnswerRequest, "typeName", "mono.projectdata.v1.ApproveRfiAnswerRequest");
_define_property(ApproveRfiAnswerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ApproveRfiAnswerResponse
 */ export class ApproveRfiAnswerResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApproveRfiAnswerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveRfiAnswerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveRfiAnswerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveRfiAnswerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiSectionView section = 1;
   */ _define_property(this, "section", void 0), /**
   * true when cp0 indexed the final in this call (best effort)
   *
   * @generated from field: bool indexed = 2;
   */ _define_property(this, "indexed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveRfiAnswerResponse, "runtime", proto3);
_define_property(ApproveRfiAnswerResponse, "typeName", "mono.projectdata.v1.ApproveRfiAnswerResponse");
_define_property(ApproveRfiAnswerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: RfiSectionView
        },
        {
            no: 2,
            name: "indexed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RequestRfiAnswerChangesRequest
 */ export class RequestRfiAnswerChangesRequest extends Message {
    static fromBinary(bytes, options) {
        return new RequestRfiAnswerChangesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestRfiAnswerChangesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestRfiAnswerChangesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestRfiAnswerChangesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string base_version_id = 3;
   */ _define_property(this, "baseVersionId", ""), /**
   * optional; added as a comment on the answer's region
   *
   * @generated from field: string note = 4;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestRfiAnswerChangesRequest, "runtime", proto3);
_define_property(RequestRfiAnswerChangesRequest, "typeName", "mono.projectdata.v1.RequestRfiAnswerChangesRequest");
_define_property(RequestRfiAnswerChangesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "base_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RequestRfiAnswerChangesResponse
 */ export class RequestRfiAnswerChangesResponse extends Message {
    static fromBinary(bytes, options) {
        return new RequestRfiAnswerChangesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RequestRfiAnswerChangesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RequestRfiAnswerChangesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RequestRfiAnswerChangesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiSectionView section = 1;
   */ _define_property(this, "section", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RequestRfiAnswerChangesResponse, "runtime", proto3);
_define_property(RequestRfiAnswerChangesResponse, "typeName", "mono.projectdata.v1.RequestRfiAnswerChangesResponse");
_define_property(RequestRfiAnswerChangesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: RfiSectionView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReindexRfiFinalAnswersRequest
 */ export class ReindexRfiFinalAnswersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReindexRfiFinalAnswersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReindexRfiFinalAnswersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReindexRfiFinalAnswersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReindexRfiFinalAnswersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * optional
   *
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: bool dry_run = 3;
   */ _define_property(this, "dryRun", false), /**
   * <= 500 (default 100)
   *
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: string page_token = 5;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReindexRfiFinalAnswersRequest, "runtime", proto3);
_define_property(ReindexRfiFinalAnswersRequest, "typeName", "mono.projectdata.v1.ReindexRfiFinalAnswersRequest");
_define_property(ReindexRfiFinalAnswersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ReindexRfiFinalAnswersResponse
 */ export class ReindexRfiFinalAnswersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReindexRfiFinalAnswersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReindexRfiFinalAnswersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReindexRfiFinalAnswersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReindexRfiFinalAnswersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 indexed = 1;
   */ _define_property(this, "indexed", 0), /**
   * @generated from field: int32 removed = 2;
   */ _define_property(this, "removed", 0), /**
   * @generated from field: int32 failed = 3;
   */ _define_property(this, "failed", 0), /**
   * @generated from field: string next_page_token = 4;
   */ _define_property(this, "nextPageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReindexRfiFinalAnswersResponse, "runtime", proto3);
_define_property(ReindexRfiFinalAnswersResponse, "typeName", "mono.projectdata.v1.ReindexRfiFinalAnswersResponse");
_define_property(ReindexRfiFinalAnswersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "indexed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ----- WRT-07: past answers -----
 *
 * @generated from message mono.projectdata.v1.SearchFinalAnswersRequest
 */ export class SearchFinalAnswersRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchFinalAnswersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchFinalAnswersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchFinalAnswersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchFinalAnswersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * <= 50; empty = every question
   *
   * @generated from field: repeated string section_ids = 2;
   */ _define_property(this, "sectionIds", []), /**
   * default 3, <= 10
   *
   * @generated from field: int32 per_question_limit = 3;
   */ _define_property(this, "perQuestionLimit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchFinalAnswersRequest, "runtime", proto3);
_define_property(SearchFinalAnswersRequest, "typeName", "mono.projectdata.v1.SearchFinalAnswersRequest");
_define_property(SearchFinalAnswersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "per_question_limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PastAnswerMatch
 */ export class PastAnswerMatch extends Message {
    static fromBinary(bytes, options) {
        return new PastAnswerMatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PastAnswerMatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PastAnswerMatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PastAnswerMatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string section_id = 2;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string rfi_title = 3;
   */ _define_property(this, "rfiTitle", ""), /**
   * @generated from field: int32 question_number = 4;
   */ _define_property(this, "questionNumber", 0), /**
   * first 160 characters of pangaea's current final_text
   *
   * @generated from field: string snippet = 5;
   */ _define_property(this, "snippet", ""), /**
   * round(cp0 score * 100)
   *
   * @generated from field: int32 pct = 6;
   */ _define_property(this, "pct", 0), /**
   * @generated from field: string final_version_id = 7;
   */ _define_property(this, "finalVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PastAnswerMatch, "runtime", proto3);
_define_property(PastAnswerMatch, "typeName", "mono.projectdata.v1.PastAnswerMatch");
_define_property(PastAnswerMatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfi_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "question_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "snippet",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pct",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "final_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PastAnswerResult
 */ export class PastAnswerResult extends Message {
    static fromBinary(bytes, options) {
        return new PastAnswerResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PastAnswerResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PastAnswerResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PastAnswerResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string question_section_id = 1;
   */ _define_property(this, "questionSectionId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PastAnswerMatch matches = 2;
   */ _define_property(this, "matches", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PastAnswerResult, "runtime", proto3);
_define_property(PastAnswerResult, "typeName", "mono.projectdata.v1.PastAnswerResult");
_define_property(PastAnswerResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question_section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "matches",
            kind: "message",
            T: PastAnswerMatch,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SearchFinalAnswersResponse
 */ export class SearchFinalAnswersResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchFinalAnswersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchFinalAnswersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchFinalAnswersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchFinalAnswersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PastAnswerResult results = 1;
   */ _define_property(this, "results", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchFinalAnswersResponse, "runtime", proto3);
_define_property(SearchFinalAnswersResponse, "typeName", "mono.projectdata.v1.SearchFinalAnswersResponse");
_define_property(SearchFinalAnswersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: PastAnswerResult,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiNavCountsRequest
 */ export class GetRfiNavCountsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiNavCountsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiNavCountsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiNavCountsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiNavCountsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiNavCountsRequest, "runtime", proto3);
_define_property(GetRfiNavCountsRequest, "typeName", "mono.projectdata.v1.GetRfiNavCountsRequest");
_define_property(GetRfiNavCountsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetRfiNavCountsResponse
 */ export class GetRfiNavCountsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiNavCountsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiNavCountsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiNavCountsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiNavCountsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 questions = 1;
   */ _define_property(this, "questions", 0), /**
   * @generated from field: int32 in_review = 2;
   */ _define_property(this, "inReview", 0), /**
   * @generated from field: int32 attachments = 3;
   */ _define_property(this, "attachments", 0), /**
   * filled by WRT-06/07
   *
   * @generated from field: int32 labor_categories = 4;
   */ _define_property(this, "laborCategories", 0), /**
   * @generated from field: int32 amendments = 5;
   */ _define_property(this, "amendments", 0), /**
   * @generated from field: int32 past_answers = 6;
   */ _define_property(this, "pastAnswers", 0), /**
   * @generated from field: int32 team = 7;
   */ _define_property(this, "team", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiNavCountsResponse, "runtime", proto3);
_define_property(GetRfiNavCountsResponse, "typeName", "mono.projectdata.v1.GetRfiNavCountsResponse");
_define_property(GetRfiNavCountsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "questions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "in_review",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "attachments",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "labor_categories",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "amendments",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "past_answers",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "team",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ----- WRT-07: labor categories and the capability statement -----
 *
 * @generated from message mono.projectdata.v1.RfiLaborCategory
 */ export class RfiLaborCategory extends Message {
    static fromBinary(bytes, options) {
        return new RfiLaborCategory().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiLaborCategory().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiLaborCategory().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiLaborCategory, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * verbatim, as the RFI wrote it
   *
   * @generated from field: string as_written_title = 2;
   */ _define_property(this, "asWrittenTitle", ""), /**
   * @generated from field: string source_question_id = 3;
   */ _define_property(this, "sourceQuestionId", ""), /**
   * @generated from field: string source_quote = 4;
   */ _define_property(this, "sourceQuote", ""), /**
   * @generated from field: string quantity_text = 5;
   */ _define_property(this, "quantityText", ""), /**
   * unmatched | matched | needs_review
   *
   * @generated from field: string match_state = 7;
   */ _define_property(this, "matchState", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * v2.3
   *
   * @generated from field: mono.projectdata.v1.RfiLcatMatch match = 9;
   */ _define_property(this, "match", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiLaborCategory, "runtime", proto3);
_define_property(RfiLaborCategory, "typeName", "mono.projectdata.v1.RfiLaborCategory");
_define_property(RfiLaborCategory, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "as_written_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "quantity_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "match_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "match",
            kind: "message",
            T: RfiLcatMatch
        }
    ]));
/**
 * v2.3: REG-17 result as registry ids; *_title / *_name / href are read-time
 * labels, never stored. No rate field exists (D5).
 *
 * @generated from message mono.projectdata.v1.RfiLcatMatch
 */ export class RfiLcatMatch extends Message {
    static fromBinary(bytes, options) {
        return new RfiLcatMatch().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiLcatMatch().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiLcatMatch().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiLcatMatch, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string lcat_anchor_id = 1;
   */ _define_property(this, "lcatAnchorId", ""), /**
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string vehicle_id = 3;
   */ _define_property(this, "vehicleId", ""), /**
   * "" | equivalent | broader | narrower | candidate
   *
   * @generated from field: string match_kind = 4;
   */ _define_property(this, "matchKind", ""), /**
   * REG-17 status
   *
   * @generated from field: string match_status = 5;
   */ _define_property(this, "matchStatus", ""), /**
   * @generated from field: repeated string ambiguous_entry_ids = 6;
   */ _define_property(this, "ambiguousEntryIds", []), /**
   * @generated from field: string matched_vehicle_basis = 7;
   */ _define_property(this, "matchedVehicleBasis", ""), /**
   * @generated from field: google.protobuf.Timestamp matched_at = 8;
   */ _define_property(this, "matchedAt", void 0), /**
   * @generated from field: string entry_title = 9;
   */ _define_property(this, "entryTitle", ""), /**
   * @generated from field: string vehicle_name = 10;
   */ _define_property(this, "vehicleName", ""), /**
   * @generated from field: string href = 11;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiLcatMatch, "runtime", proto3);
_define_property(RfiLcatMatch, "typeName", "mono.projectdata.v1.RfiLcatMatch");
_define_property(RfiLcatMatch, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lcat_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "match_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "match_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "ambiguous_entry_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "matched_vehicle_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "matched_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "entry_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiLaborCategoriesRequest
 */ export class ListRfiLaborCategoriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiLaborCategoriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiLaborCategoriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiLaborCategoriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiLaborCategoriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiLaborCategoriesRequest, "runtime", proto3);
_define_property(ListRfiLaborCategoriesRequest, "typeName", "mono.projectdata.v1.ListRfiLaborCategoriesRequest");
_define_property(ListRfiLaborCategoriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListRfiLaborCategoriesResponse
 */ export class ListRfiLaborCategoriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiLaborCategoriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiLaborCategoriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiLaborCategoriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiLaborCategoriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiLaborCategory items = 1;
   */ _define_property(this, "items", []), /**
   * rfiEffectiveVehicleID (WRT-06): what REG-17 matches against; "" = set the vehicle first
   *
   * @generated from field: string effective_vehicle_id = 2;
   */ _define_property(this, "effectiveVehicleId", ""), /**
   * false until REG-17 ships ("Arrives with the registry matcher")
   *
   * @generated from field: bool matcher_available = 3;
   */ _define_property(this, "matcherAvailable", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiLaborCategoriesResponse, "runtime", proto3);
_define_property(ListRfiLaborCategoriesResponse, "typeName", "mono.projectdata.v1.ListRfiLaborCategoriesResponse");
_define_property(ListRfiLaborCategoriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: RfiLaborCategory,
            repeated: true
        },
        {
            no: 2,
            name: "effective_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "matcher_available",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiLaborCategoriesRequest
 */ export class CreateRfiLaborCategoriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiLaborCategoriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiLaborCategoriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiLaborCategoriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiLaborCategoriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.RfiLaborCategory items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiLaborCategoriesRequest, "runtime", proto3);
_define_property(CreateRfiLaborCategoriesRequest, "typeName", "mono.projectdata.v1.CreateRfiLaborCategoriesRequest");
_define_property(CreateRfiLaborCategoriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: RfiLaborCategory,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateRfiLaborCategoriesResponse
 */ export class CreateRfiLaborCategoriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiLaborCategoriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiLaborCategoriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiLaborCategoriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiLaborCategoriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.RfiLaborCategory created = 1;
   */ _define_property(this, "created", []), /**
   * @generated from field: int32 skipped_duplicates = 2;
   */ _define_property(this, "skippedDuplicates", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiLaborCategoriesResponse, "runtime", proto3);
_define_property(CreateRfiLaborCategoriesResponse, "typeName", "mono.projectdata.v1.CreateRfiLaborCategoriesResponse");
_define_property(CreateRfiLaborCategoriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "created",
            kind: "message",
            T: RfiLaborCategory,
            repeated: true
        },
        {
            no: 2,
            name: "skipped_duplicates",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiLaborCategoryRequest
 */ export class UpdateRfiLaborCategoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiLaborCategoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiLaborCategoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiLaborCategoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiLaborCategoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: mono.projectdata.v1.RfiLaborCategory item = 2;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiLaborCategoryRequest, "runtime", proto3);
_define_property(UpdateRfiLaborCategoryRequest, "typeName", "mono.projectdata.v1.UpdateRfiLaborCategoryRequest");
_define_property(UpdateRfiLaborCategoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item",
            kind: "message",
            T: RfiLaborCategory
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiLaborCategoryResponse
 */ export class UpdateRfiLaborCategoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiLaborCategoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiLaborCategoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiLaborCategoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiLaborCategoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiLaborCategory item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiLaborCategoryResponse, "runtime", proto3);
_define_property(UpdateRfiLaborCategoryResponse, "typeName", "mono.projectdata.v1.UpdateRfiLaborCategoryResponse");
_define_property(UpdateRfiLaborCategoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RfiLaborCategory
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveRfiLaborCategoryRequest
 */ export class RemoveRfiLaborCategoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveRfiLaborCategoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveRfiLaborCategoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveRfiLaborCategoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveRfiLaborCategoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveRfiLaborCategoryRequest, "runtime", proto3);
_define_property(RemoveRfiLaborCategoryRequest, "typeName", "mono.projectdata.v1.RemoveRfiLaborCategoryRequest");
_define_property(RemoveRfiLaborCategoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RemoveRfiLaborCategoryResponse
 */ export class RemoveRfiLaborCategoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveRfiLaborCategoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveRfiLaborCategoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveRfiLaborCategoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveRfiLaborCategoryResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveRfiLaborCategoryResponse, "runtime", proto3);
_define_property(RemoveRfiLaborCategoryResponse, "typeName", "mono.projectdata.v1.RemoveRfiLaborCategoryResponse");
_define_property(RemoveRfiLaborCategoryResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiLaborCategoryMatchRequest
 */ export class UpdateRfiLaborCategoryMatchRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiLaborCategoryMatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiLaborCategoryMatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiLaborCategoryMatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiLaborCategoryMatchRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * true = reset to unmatched; false = zou runs REG-17 for this row now
   *
   * @generated from field: bool clear = 5;
   */ _define_property(this, "clear", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiLaborCategoryMatchRequest, "runtime", proto3);
_define_property(UpdateRfiLaborCategoryMatchRequest, "typeName", "mono.projectdata.v1.UpdateRfiLaborCategoryMatchRequest");
_define_property(UpdateRfiLaborCategoryMatchRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "clear",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UpdateRfiLaborCategoryMatchResponse
 */ export class UpdateRfiLaborCategoryMatchResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRfiLaborCategoryMatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRfiLaborCategoryMatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRfiLaborCategoryMatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRfiLaborCategoryMatchResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiLaborCategory item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRfiLaborCategoryMatchResponse, "runtime", proto3);
_define_property(UpdateRfiLaborCategoryMatchResponse, "typeName", "mono.projectdata.v1.UpdateRfiLaborCategoryMatchResponse");
_define_property(UpdateRfiLaborCategoryMatchResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: RfiLaborCategory
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureRfiCapabilityStatementRequest
 */ export class EnsureRfiCapabilityStatementRequest extends Message {
    static fromBinary(bytes, options) {
        return new EnsureRfiCapabilityStatementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureRfiCapabilityStatementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureRfiCapabilityStatementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureRfiCapabilityStatementRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * WRT-35: "section" (default) | "separate_document" (not built yet)
   *
   * @generated from field: string placement = 2;
   */ _define_property(this, "placement", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureRfiCapabilityStatementRequest, "runtime", proto3);
_define_property(EnsureRfiCapabilityStatementRequest, "typeName", "mono.projectdata.v1.EnsureRfiCapabilityStatementRequest");
_define_property(EnsureRfiCapabilityStatementRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "placement",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.EnsureRfiCapabilityStatementResponse
 */ export class EnsureRfiCapabilityStatementResponse extends Message {
    static fromBinary(bytes, options) {
        return new EnsureRfiCapabilityStatementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EnsureRfiCapabilityStatementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EnsureRfiCapabilityStatementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EnsureRfiCapabilityStatementResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.RfiSectionView section = 1;
   */ _define_property(this, "section", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EnsureRfiCapabilityStatementResponse, "runtime", proto3);
_define_property(EnsureRfiCapabilityStatementResponse, "typeName", "mono.projectdata.v1.EnsureRfiCapabilityStatementResponse");
_define_property(EnsureRfiCapabilityStatementResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section",
            kind: "message",
            T: RfiSectionView
        }
    ]));
